"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyError = exports.logger = void 0;
var _lodash = require("lodash");
// import { IconNotificationAlert } from '@shared';
// import React from 'react';

var stringifyError = function stringifyError(err) {
  if (!err) {
    return 'Unknown error';
  }
  if ((0, _lodash.isString)(err)) {
    return err;
  }
  if (err.isAxiosError) {
    return JSON.stringify(err);
  }
  var errorStringified = (err === null || err === void 0 ? void 0 : err.message) || err;
  try {
    var stringified = JSON.stringify(err);

    // case when `err instanceof Error // true` but no properties is set
    // except 'message' passed in constructor
    return stringified === '{}' ? errorStringified : stringified;
  } catch (e) {
    return (err === null || err === void 0 ? void 0 : err.message) || err;
  }
};

// This may be evolved for things like...
// - Passing error messages along to HoneyBadger
// - Logging additional info for common or known error types
// - Configurable log levels
exports.stringifyError = stringifyError;
var logger = {
  error: function error(component, _error) {
    console.error("[".concat(component, "]"), _error);
    if (_error.response) {
      console.error("[".concat(component, "] response:"), _error.response);
    }
    if (window.Honeybadger) {
      window.Honeybadger.notify(_error, {
        component: component
      });
    }
  }
};
exports.logger = logger;